'use strict'

const debounce = require('lodash/debounce');
const constants = require("../constants");
const getWindowSizes = require('../utils/getWindowSizes');
const SELECTORS = {
    object: '.js-zoom-image-object',
    element: '.js-zoom-image',
    parent: '.js-zoom-image-wrap'
}
const CLASSES = {
    zoomed: 'cc-zoomed',
}

/**
 * Creates the zoom effect on the image by setting the transform origin to the mouse/touch position and scaling the image to 2
 * @param {Event} evt - The event object
 * @param {Number} x - The x position of the mouse/touch
 * @param {Number} y - The y position of the mouse/touch
 */
const createZoomEffect = (evt, x, y) => {
    // NOTE: We had to move function out of the class scope since we cannot bind the this context to the event listener
    evt.target.style.transformOrigin = `${x}px ${y}px`;
    evt.target.style.transform = 'scale(2.5)';
    evt.target.classList.add(CLASSES.zoomed);
    setTimeout(() => {
        $(evt.target).trigger('active');
        evt.target.style.transition = 'unset';
    }, constants.defaultAnimationTimeout);
}

/**
 * ImageZoom class that handles the zoom effect on the product image
 */
class ImageZoom {
    constructor(element) {
        this.object = $(SELECTORS.object);
        this.element = this.object.find(SELECTORS.element);
        this.parent = this.element.closest(SELECTORS.parent);
        this.isMoving = false;
        this.initEvents();
        this.onResize();
    }

    /**
     * Re-initialize the events for the image zoom
     */
    onResize() {
        $(window).on('resize', debounce(() => {
            $('body').off('mousemove', SELECTORS.element, this.zoomOnImage);
            this.initEvents();
        }, 100));
    }

    /**
     * Initialize the events for the image zoom
     */
    initEvents() {
        getWindowSizes();
        if (window.isDesktop) {
            $('body').off('click', SELECTORS.element).on('click', SELECTORS.element, (evt) => {
                evt.preventDefault();
                evt.currentTarget.style.transition = constants.defaultTransition;
                if ($(evt.target).hasClass(CLASSES.zoomed)) {
                    this.zoomOutImage(evt);
                    return;
                }

                this.zoomOnImage(evt)
                $('body').on('mousemove', SELECTORS.element, this.zoomOnImage);
            });

            $('body').off('mouseleave', SELECTORS.element).on('mouseleave', SELECTORS.element, (evt) => {
                this.zoomOutImage(evt);
            });
        } else {
            $('body').off('touchmove', SELECTORS.element).on('touchmove', SELECTORS.element, (evt) => {
                this.isMoving = true;
                this.zoomOnImageMobile(evt);
            });

            $('body').off('touchend', SELECTORS.element).on('touchend', SELECTORS.element, (evt) => {
                if (evt.cancelable) evt.preventDefault();
                if (!this.isMoving) {
                    evt.currentTarget.style.transition = constants.defaultTransition;
                    if ($(evt.target).hasClass(CLASSES.zoomed)) {
                        this.zoomOutImage(evt);
                    } else {
                        this.zoomOnImage(evt);
                    }
                }
                this.isMoving = false;
                $(SELECTORS.object).slick('slickSetOption', 'swipe', true);
            });
        }
    }

    /**
     * Creates the zoom effect on the image based on the mouse position
     * @param {Event} evt - The event object
     */
    zoomOnImage(evt) {
        const parent = $(evt.currentTarget).closest(SELECTORS.parent);
        const x = evt.clientX - parent.offset().left;
        const y = evt.clientY - parent.offset().top + window.scrollY;
        createZoomEffect(evt, x, y);
    }

    /**
     * Creates the zoom effect on the image based on the touch position
     * @param {Event} evt - The event object
     */
    zoomOnImageMobile(evt) {
        if ($(evt.target).hasClass(CLASSES.zoomed)) {
            evt.preventDefault();
            evt.stopPropagation();
            $(SELECTORS.object).slick('slickSetOption', 'swipe', false);
            const parent = $(evt.currentTarget).closest(SELECTORS.parent);
            const parentW = parent.outerWidth();
            const parentH = parent.outerHeight();
            const x = Math.max(0, Math.min(evt.changedTouches[0].pageX - parent.offset().left, parentW));
            const y = Math.max(0, Math.min(evt.changedTouches[0].pageY - parent.offset().top, parentH));
            createZoomEffect(evt, x, y);
        }
    }

    /**
     * Resets the zoom effect on the image by setting the scale to 1 and the transform origin to unset
     * @param {Event} evt - The event object
     */
    zoomOutImage(evt) {
        evt.target.style.transform = 'scale(1)';
        evt.target.style.transformOrigin = 'unset';
        evt.target.classList.remove(CLASSES.zoomed);
        if (window.isDesktop) {
            $('body').off('mousemove', SELECTORS.element, this.zoomOnImage);
        }
    }
}

module.exports = () => {
    $(SELECTORS.object).each((index, element) => {
        new ImageZoom($(element));
    });

    $('body').on('product:afterAttributeSelect', () => {
        $(SELECTORS.object).each((index, element) => {
            new ImageZoom($(element));
        });
    });
}